import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import CommentModal from "components/Next/Comments/CommentModal";

import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as adminReducer from "containers/Admin/reducer";

class CommentModalContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <CommentModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createComment: (comment) =>
      dispatch(nextModelsReducer.createComment(comment, ownProps.isModels === true ? false : true)),
    updateIsCommentModal: (isCommentModal) =>
      dispatch(nextModelsReducer.updateIsCommentModal(ownProps.id, isCommentModal))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    comment: nextModelsReducer.getIsCommentModal(state, ownProps.id),
    users: adminReducer.getUsers(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(CommentModalContainer);
